import { createAsyncThunk } from '@reduxjs/toolkit'
import userService from 'services/user/user.service'
import waiverService from 'services/waiver/waiver.service'

export const setUserFamily = createAsyncThunk(
  'users/set-user-family',
  userService.setUserFamily
)
export const removeUserFamily = createAsyncThunk(
  'users/remove-user-family',
  userService.removeUserFamily
)
export const createChild = createAsyncThunk(
  'users/create-child',
  userService.createChild
)
export const getChildren = createAsyncThunk(
  'users/get-children',
  userService.getChildren
)
export const editChild = createAsyncThunk(
  'users/edit-child',
  userService.editChild
)
export const getFamilyMemberAppointments = createAsyncThunk(
  'users/get-family-member-appointments',
  userService.getFamilyMemberAppointments
)
export const updateUserProfile = createAsyncThunk(
  'users/update-profile',
  userService.updateProfile
)
export const changeUserPassword = createAsyncThunk(
  'users/change-password',
  userService.changePassword
)
export const getUserAppointments = createAsyncThunk(
  'users/get-users-appointments',
  userService.getUserAppointments
)
export const getUserProfile = createAsyncThunk(
  'users/get-users-profile',
  userService.getUserProfile
)
export const getUserTransactionsByLocation = createAsyncThunk(
  'users/get-users-transactions',
  userService.getUserTransactionsByLocationId
)
export const getUserTransactions = createAsyncThunk(
  'users/get-all-user-transactions',
  (args: { userId: number; page?: number; limit?: number }) =>
    userService.getUserTransactions(args.userId, args.page, args.limit)
)
export const resendReceipt = createAsyncThunk(
  'users/resend-receipt',
  userService.resendReceipt
)
export const getUserBalance = createAsyncThunk(
  'users/get-users-balance',
  userService.getUserBalance
)
export const getWaiverStatusForUser = createAsyncThunk(
  'waiver/get-waiver-status',
  waiverService.getWaiverStatusForUser
)
export const postWaiverStatusForUser = createAsyncThunk(
  'waiver/post-waiver-status',
  waiverService.postWaiverStatusForUser
)
